module.exports = __webpack_public_path__ + "static/media/search-minus.bb5fafbd.svg";